// extracted by mini-css-extract-plugin
module.exports =  {"body":"body--c0UZQ","body-grid":"body-grid--jzfTU","bodyGrid":"body-grid--jzfTU"};